const routes = [
    {
        path: '/photo-manager/add-photo/:photoType/:pid?',
        async lazy() {
            const { AddPhotoScreen } = await import(
            /* webpackChunkName: "photo-manager" */
            './PhotoManagerLazyLoader');
            return { Component: AddPhotoScreen };
        },
    },
    {
        path: '/photo-manager/view-photos/:photoType/:pid?',
        async lazy() {
            const { ViewPhotosScreen } = await import(
            /* webpackChunkName: "photo-manager" */
            './PhotoManagerLazyLoader');
            return { Component: ViewPhotosScreen };
        },
    },
];
export default routes;
